import Api from '@/api/Api'
import toast from '@/mixins/toast'

export default {
        
    // add single waypoint
    addWaypoint (payload) {
        return Api().post('/waypoint', payload).then( (response) => {
                return response.data
            }) 
            .catch( error => { 
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    // add array of waypoints
    addWaypoints (payload) {
        return Api().post('/waypoints', payload).then( (response) => {
                return response.data
            }) 
            .catch( error => { 
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    // add single convoy
    addConvoy (payload) {
    	return Api().post('/convoy', payload).then( (response) => {
                return response.data
            }) 
            .catch( error => {
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    // add array of convoys
    addConvoys (payload) {
    	return Api().post('/convoys', payload).then( (response) => {
                return response.data
            }) 
            .catch( error => {
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    addTravel (payload) {
    	return Api().post('/travel', payload).then( (response) => {
                return response.data
            }) 
            .catch( error => {
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
     // add single participant
    addParticipant (payload) {
    	return Api().post('/participant', payload).then( (response) => {
                return response.data
            }) 
            .catch( error => {
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    // add array participants
    addParticipants (payload) {
        return Api().post('/participants', payload).then( (response) => {
                return response.data
            }) 
            .catch( error => {
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    // add single vehicle
    addVehicle (payload) {
    	return Api().post('/vehicle', payload).then( (response) => {
                return response.data
            }) 
            .catch( error => {
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    // add array vehicles
    addVehicles (payload) {
        return Api().post('/vehicles', payload).then( (response) => {
                return response.data
            }) 
            .catch( error => {
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    // add single truck
    addTruck (payload) {
    	return Api().post('/truck', payload).then( (response) => {
                return response.data
            }) 
            .catch( error => {
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
     // add array trucks
    addTrucks (payload) {
        return Api().post('/trucks', payload).then( (response) => {
                return response.data
            }) 
            .catch( error => {
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    // add single photo
    addPhoto (payload) {
    	return Api().post('/photo', payload).then( (response) => {
                return response.data
            }) 
            .catch( error => {
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    // add array photos
    addPhotos (payload) {
        return Api().post('/photos', payload).then( (response) => {
                return response.data
            }) 
            .catch( error => {
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    // get array of waypoints
    getWaypoints (payload) {
        return Api().get('/waypoints/'+ payload).then( (response) => {
                return response.data
            }) 
            .catch( error => { 
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    // get array of convoys
    getConvoys (payload) {
        return Api().get('/convoys/'+ payload).then( (response) => {
                return response.data
            }) 
            .catch( error => { 
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    // get array of participants
    getParticipants (payload) {
        return Api().get('/participants/'+ payload).then( (response) => {
                return response.data
            }) 
            .catch( error => { 
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    // get array of vehicles
    getVehicles (payload) {
        return Api().get('/vehicles/'+ payload).then( (response) => {
                return response.data
            }) 
            .catch( error => { 
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    // get array of trucks
    getTrucks (payload) {
        return Api().get('/trucks/'+ payload).then( (response) => {
                return response.data
            }) 
            .catch( error => { 
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },
    // get array of photos
    getPhotos (payload) {
        return Api().get('/upload/'+ payload).then( (response) => {
                return response.data
            }) 
            .catch( error => { 
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    }

}


// WEBPACK FOOTER //
// ./src/api/LandMovementService.js